var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "sample-header-image",
    attrs: {
      "src": require("./images/sample_form_header.jpg"),
      "width": "100%"
    }
  }), _c('b-card-group', {
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "HUGGIES好奇裸感好動褲派樣包申請活動",
      "header-tag": "header"
    }
  }, [_c('b-card-text', [_vm._v("謝謝您申請好奇裸感好動褲派樣包，請務必填寫完成表單資料，並確認收到LINE成功申請訊息")])], 1)], 1), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "name"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("會員姓名"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "placeholder": "請輸入真實姓名",
      "state": _vm.v$.form.name.$invalid ? false : null
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$invalid
    }
  }, [_vm._v(" 請輸入真實姓名 ")])], 1)], 1), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "telephone"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("聯絡電話"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('b-form-text', [_vm._v("若手機號碼重新輸入，會員表單裡電話資料會同步修改 ")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "telephone",
      "placeholder": "請輸入手機號碼",
      "state": _vm.v$.form.telephone.$invalid ? false : null
    },
    model: {
      value: _vm.form.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telephone", $$v);
      },
      expression: "form.telephone"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.telephone.$invalid
    }
  }, [_vm._v(" 請輸入手機號碼 ")])], 1)], 1), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "address"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("收取派樣包地址"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('b-form-text', [_vm._v("請填妥：郵遞區號/ 縣市 / 鄉鎮市區 / 路 巷 弄 號 / 樓 室 【*若資料不完整或地址無法辨識，將無法完成寄件。】 ")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "address",
      "state": _vm.v$.form.address.$invalid ? false : null,
      "placeholder": "請輸入文字"
    },
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.address.$invalid
    }
  }, [_vm._v(" 請輸入文字 ")])], 1)], 1), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "email"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("e-mail"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "email",
      "placeholder": "請輸入 email",
      "state": _vm.v$.form.email.$invalid ? false : null
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.email.$invalid
    }
  }, [_vm._v(" 請輸入 e-mail ")])], 1)], 1), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "sample_size",
      "state": _vm.v$.form.sample_size.$invalid ? false : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("寶寶尿布尺寸"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('b-form-text', [_vm._v("若兩個尺寸都已領取完畢，即表示申請已宣告結束，歡迎下次活動持續參與，謝謝您! ")]), _c('b-form-radio-group', {
    staticClass: "sample-radio",
    attrs: {
      "name": "radio-options",
      "options": _vm.sizeOptions,
      "state": _vm.v$.form.sample_size.$invalid ? false : null,
      "stacked": ""
    },
    model: {
      value: _vm.form.sample_size,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sample_size", $$v);
      },
      expression: "form.sample_size"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-2",
    staticStyle: {
      "background": "#5c7580",
      "color": "#fff"
    },
    attrs: {
      "size": "lg"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v("送出")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }